import m from "../../geodata/es2015/turkeyHigh";
window.am4geodata_turkeyHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/turkeyHigh.js
// module id = null
// module chunks = 